// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1q7Z1","col":"CardReaderDesc_col__ImWOZ","label":"CardReaderDesc_label__3D9wO"};